import React from "react"

const Terms: React.FC = (): React.ReactElement => {
  return (
    <a href="https://prismancy.com/policy/terms" className="type-link border-0 p-0 m-0" target="_blank" rel="noreferrer">Terms</a>
  )
}

export default Terms
